var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBurgerLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 17,
    x: 0,
    y: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#182326",
    fillRule: "evenodd",
    d: "M1.5 0C.67157555 0 0 .65237045 0 1.45715714c0 .8047409.67157555 1.45715713 1.5 1.45715713h17c.82842255 0 1.5-.65241623 1.5-1.45715713C20 .65237045 19.32842255 0 18.5 0h-17zm0 7.04292297c-.82842445 0-1.5.65236664-1.5 1.45716095 0 .8047409.67157555 1.45716095 1.5 1.45716095h17c.82842255 0 1.5-.65242004 1.5-1.45716095 0-.8047943-.67157745-1.45716095-1.5-1.45716095h-17zM0 15.54301453c0-.80479432.67157555-1.45716095 1.5-1.45716095h17c.82842255 0 1.5.65236663 1.5 1.45716095 0 .80473327-.67157745 1.45715332-1.5 1.45715332h-17c-.82842445 0-1.5-.65242005-1.5-1.45715332z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurgerLight);
export default __webpack_public_path__ + "static/media/menu_burger_light.ae42b5183c281f06ef0fdf5aae5161d2.svg";
export { ForwardRef as ReactComponent };